/*
 *
 * Order Form Header
 *
 */

import React from "react";
import Helmet from "react-helmet";
import { Col, Row } from "react-bootstrap";
import { string } from "prop-types";

const Header = ({ title }) => (
  <div>
    <Helmet
      title="Ordering Info - Criteria"
      meta={[{ name: "description", content: "Description of Order Form" }]}
    />
    <Row>
      <Col>
        <h1 className="my-4 order-form-header">{title}</h1>
      </Col>
    </Row>
  </div>
);

Header.propTypes = {
  title: string.isRequired,
};

export default Header;
